import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppContextProvider } from './AppContext';
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/react";

// --- START: CONSOLE.LOG HOOK ---
// Place this code at the very top of the file.
const originalLog = console.log;

console.log = function(...args) {
  const timestamp = `${new Date().toISOString()} |`;
  originalLog.apply(console, [timestamp, ...args]);
};
// --- END: CONSOLE.LOG HOOK ---


ReactDOM.render(
  <React.StrictMode>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

Sentry.init({
  dsn: "https://74f3f8dc864c442e9b1b11497502c46e@o575806.ingest.sentry.io/5855438",
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
});
